// ------------------------------------------------------------------------------
// InvitedArtistCard
// author: mudas
// created: 2025/6/30
// ------------------------------------------------------------------------------

import React, { FC } from 'react';
import { isVideoFile, toHomepage } from 'common/utils';

import { ArtWorkType } from 'common/types';
import { UserDefaultAvatar } from 'common/constants';
import { AiRecommendArtist } from 'common/components/TaskPublish/common/types';

import { SwapRightOutlined } from '@ant-design/icons';
import { Avatar, Carousel, Icon, Image, Typography } from '@fuxi/eevee-ui';
import { AvgScoreTag, SecondaryButton } from 'common/components';
import ArtistTag from 'common/components/ArtistTag';
// import ArtWorkCard from 'common/components/ArtWorkCard';

import cx from './InvitedArtistCard.module.css';

export interface IProps {
  data?: AiRecommendArtist;
  selected?: boolean;
  isOwn?: boolean; // 当前卡片是否为自己，默认不允许邀请自己
  className?: string;

  onInviteClick?: (data: AiRecommendArtist) => void;
  onWorkClick?: (work: ArtWorkType) => void;
}

const InvitedArtistCard: FC<IProps> = (props) => {
  const { data, isOwn, selected, className, onInviteClick, onWorkClick } = props;
  const nickname = data?.nickName || data?.mediaNickname;

  return (
    <div className={`bg-elevated p-3 rounded-xl ${className}`}>
      <div className="grid grid-cols-[max-content_1fr_max-content] items-center gap-2">
        <Avatar
          size={46}
          src={data?.avatar || UserDefaultAvatar}
          className="cursor-pointer"
          onClick={() => toHomepage(data)}
        />
        <div className="flex flex-col overflow-hidden pr-4">
          <Typography.Title ellipsis={{ tooltip: nickname }} className="text-size-sm! mb-0!">
            {nickname}
          </Typography.Title>
          <div className="flex items-center overflow-hidden pointer-events-none">
            {!!data?.avgScore && <AvgScoreTag>{data?.avgScore}</AvgScoreTag>}
            <ArtistTag mini userCertifyType={data?.userCertifyType as any} />
          </div>
        </div>
        <SecondaryButton
          shape="round"
          onClick={() => data && onInviteClick?.(data)}
          className="w-84px h-30px gap-2px"
          disabled={isOwn || selected}>
          <Icon name="Invite" className="color-primary mt-1px" />
          {selected ? '已邀请' : '邀请'}
        </SecondaryButton>
      </div>
      <div className="mt-2">
        <Carousel className={cx('carousel')} arrows draggable dots={false} infinite={false}>
          {data?.artwork?.map((artwork, index) => (
            // <ArtWorkCard key={index} width="100%" height={188} artwork={artwork} onClick={onWorkClick} />
            <Image
              key={index}
              src={artwork?.previewUrl}
              width="100%"
              height={188}
              className="rounded-2 object-cover"
              onClick={() => onWorkClick?.(artwork)}
              preview={{
                zIndex: 100,
                mask: false,
                styles: { mask: { backdropFilter: 'blur(6px)' } },
                imageRender: () => {
                  return (
                    <div className="flex-center w-100% h-100% py-20 pb-30 px-10">
                      {isVideoFile(artwork?.artworkName) ? (
                        <video src={artwork?.artworkUrl} controls className="w-100% h-100%" />
                      ) : (
                        <Image
                          preview={false}
                          alt={artwork.artworkName}
                          src={artwork?.artworkUrl}
                          wrapperClassName="w-100% h-100%"
                          className="object-contain h-100%!"
                        />
                      )}

                      <SecondaryButton
                        iconPosition="end"
                        icon={<SwapRightOutlined />}
                        className="w-240px h-52px pos-absolute bottom-20px"
                        style={{ backdropFilter: 'blur(5px)', backgroundColor: 'var(--color-fill)' }}
                        onClick={() => toHomepage(data)}>
                        <Typography.Text className="font-s-heading-4">查看主页</Typography.Text>
                      </SecondaryButton>
                    </div>
                  );
                },
                toolbarRender: () => null,
              }}
            />
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default InvitedArtistCard;
